import { HighContrastSelector } from '../../../Styling';
export function getStyles(props) {
  var _a;

  return {
    root: [{
      position: 'absolute',
      boxShadow: 'inherit',
      border: 'none',
      boxSizing: 'border-box',
      transform: props.transform,
      width: props.width,
      height: props.height,
      left: props.left,
      top: props.top,
      right: props.right,
      bottom: props.bottom
    }],
    beak: {
      fill: props.color,
      display: 'block',
      selectors: (_a = {}, _a[HighContrastSelector] = {
        fill: 'windowtext'
      }, _a)
    }
  };
}